(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-custom"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery {
    constructor(container) {
      this.container = container;
      this.thumbnails = this.container.querySelectorAll('.media-gallery__thumbnail');
      this.mainMediaItems = this.container.querySelectorAll('.main-media-item');
      this.modalOpeners = this.container.querySelectorAll('.product-media-modal__opener');
      
      this.init();
    }
    
    init() {
      // Ensure we have both thumbnails and main media items
      if (this.thumbnails.length === 0 || this.mainMediaItems.length === 0) {
        console.error('Missing thumbnails or media items');
        return;
      }
      
      // Apply click handlers to thumbnails
      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', this.handleThumbnailClick.bind(this, thumbnail));
      });
      
      // Set first thumbnail as active if none are active
      if (!this.container.querySelector('.media-gallery__thumbnail.is-active') && this.thumbnails.length > 0) {
        this.thumbnails[0].classList.add('is-active');
      }
      
      // Initialize modal openers
      this.modalOpeners.forEach(button => {
        button.addEventListener('click', this.handleModalOpen.bind(this, button));
      });
    }
    
    handleModalOpen(button, event) {
      event.preventDefault();
      
      // Get section ID from container data attribute
      const sectionId = this.container.getAttribute('data-section-id');
      const modal = document.getElementById(`ProductModal-${sectionId}`);
      
      if (modal) {
        modal.show(button);
      }
    }
    
    handleThumbnailClick(thumbnail, event) {
      event.preventDefault();
      
      const mediaId = thumbnail.getAttribute('data-media-id');
      console.log(`Thumbnail clicked: ${mediaId}`);
      
      // Update active state on thumbnails
      this.thumbnails.forEach(t => t.classList.remove('is-active'));
      thumbnail.classList.add('is-active');
      
      // Show/hide main media items
      this.mainMediaItems.forEach(item => {
        const itemId = item.getAttribute('data-media-id');
        if (itemId === mediaId) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    }
  }
  
  // Initialize all product galleries in the document
  function initializeProductGalleries() {
    const galleryContainers = document.querySelectorAll('.custom-product-page');
    galleryContainers.forEach(container => {
      new ProductGallery(container);
    });
  }
  
  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', initializeProductGalleries);
  
  // Also initialize immediately if DOM is already loaded
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(initializeProductGalleries, 1);
  }
  
  // Re-initialize when any Shopify section is reloaded
  document.addEventListener('shopify:section:load', (event) => {
    // Initialize all galleries after any section loads
    initializeProductGalleries();
  });

  } catch(e) { console.error(e); }
})();
})();
